import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from '@angular-material-extensions/select-country';

@Injectable( {
  providedIn: 'root',
} )
export class LanguageDataService {
  private http = inject(HttpClient);


  constructor() {}

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>( 'assets/country.json' );
  }

  getLanguages(): Observable<{ languages: { name: string, code: string }[] }> {
    return this.http.get<{ languages: { name: string, code: string }[] }>( 'assets/language.json' );
  }

}
